<nav class="topnav navbar navbar-expand shadow justify-content-between justify-content-sm-start navbar-light bg-white" aria-label="Top navigation">
    <button class="btn btn-icon btn-transparent-dark ms-2" id="sidebarToggle" data-cy="topNavToggleSideNav" (click)="toggleSideNav()">
        <i-feather name="menu"></i-feather>
    </button>
    <a class="navbar-brand px-2 ps-lg-2" routerLink="/dashboard">
        <img class="logo d-none d-sm-block" src="assets/icons/logo.svg" alt="logo" />
        <img class="logo-isotipo d-block d-sm-none" src="assets/icons/Isotipo_fina.png" alt="logo" />
    </a>
    <div class="topnav-onboarding-progress">
        <fina-onboarding-navbar-progress variant="compact" heading="Configura tu cuenta"></fina-onboarding-navbar-progress>
    </div>
    <ul class="navbar-nav align-items-center ms-auto me-lg-4">
        <!-- Fina Pago: «Activar» / «Verificar» a la izquierda de «Vender» (prototipo del handoff). -->
        <fina-fina-pago-topnav-pill class="me-2 me-lg-3"></fina-fina-pago-topnav-pill>
        <button
            *ngIf="(userService.user$ | async)?.permissions.POS.includes('open-direct-and-open-sales')"
            class="btn btn-new-sale me-2 me-lg-3 px-3 px-lg-5"
            routerLink="/pos/direct-sales"
            (click)="analyticsService.analyticsCapture('sale_opened sale', { lugar: 'top-nav' })"
        >
            <i-feather name="shopping-cart" class="me-1 me-lg-2 text-white"></i-feather>
            <span class="d-none d-sm-inline">Vender</span>
            <span class="d-sm-none">Pedido</span>
        </button>
        <fina-form-fixed-variable-expenses
            *ngIf="(hasCreatePermission$ | async) && (plansService.planInvalid$ | async) === false"
            class="me-2 me-lg-3"
            [location]="'top-nav'"
            [compactMode]="isSmallScreen"
        ></fina-form-fixed-variable-expenses>
        <sbpro-top-nav-user></sbpro-top-nav-user>
    </ul>
</nav>
